import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=228ac1e0&"
import script from "./NumberField.vue?vue&type=script&lang=js&"
export * from "./NumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228ac1e0')) {
      api.createRecord('228ac1e0', component.options)
    } else {
      api.reload('228ac1e0', component.options)
    }
    module.hot.accept("./NumberField.vue?vue&type=template&id=228ac1e0&", function () {
      api.rerender('228ac1e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/NumberField.vue"
export default component.exports